export const housingTypeConstants = {
  HOUSINGTYPE_GETLIST_SUCCESS: 'HOUSINGTYPE_GETLIST_SUCCESS',
  HOUSINGTYPE_GETLIST_FAIL: 'HOUSINGTYPE_GETLIST_FAIL',

  HOUSINGTYPE_SELECTED: 'HOUSINGTYPE_SELECTED',

  RESET_HOUSINGTYPES: 'RESET_HOUSINGTYPES'
};
